import { Heart, CheckCircle2, ExternalLink } from "lucide-react";
import { PARTNER_LINK } from "@/lib/constants";

const bullets = [
  "Keine Mehrkosten für dich beim Kauf",
  "Unterstützt unabhängige Produkttests und Reviews",
  "Hilft bei Vergleichen, Interviews und Erfahrungsberichten",
  "Ermöglicht mehr deutschsprachigen Content zu Rotlichttherapie und Longevity",
];

const PartnerlinkSupportSection = () => (
  <section id="partnerlink-support" className="border-y border-border/50 bg-card/30 py-10 md:py-16">
    <div className="container">
      <div className="mx-auto max-w-3xl">
        <div className="flex items-start gap-3">
          <div className="mt-1 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-primary/15 text-primary">
            <Heart className="h-4 w-4" aria-hidden="true" />
          </div>
          <div>
            <h2 className="font-display text-xl font-bold text-foreground sm:text-2xl md:text-3xl">
              Warum über meinen heilys Partnerlink kaufen?
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground md:text-base">
              Dein Kauf über den Partnerlink hilft dabei, weiterhin ausführliche Tests, Vergleiche und Erfahrungsberichte zu Rotlichttherapie,
              Lichtgesundheit und Longevity zu erstellen. Für dich entstehen keine Mehrkosten. Gleichzeitig
              unterstützt du unabhängigen Content, Produkttests und ehrliche Einordnungen.
            </p>
          </div>
        </div>

        <ul className="mt-6 grid gap-2 sm:grid-cols-2">
          {bullets.map((b) => (
            <li key={b} className="flex items-start gap-2 rounded-lg border border-border/50 bg-card p-3 text-sm text-foreground">
              <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
              <span>{b}</span>
            </li>
          ))}
        </ul>

        <div className="mt-6">
          <a
            href={PARTNER_LINK}
            target="_blank"
            rel="sponsored noopener noreferrer"
            onClick={() => window.lh?.trackAffiliate({ source: "partnerlink_support" })}
            className="inline-flex items-center gap-1.5 rounded-lg bg-primary px-6 py-3 text-sm font-semibold text-primary-foreground shadow-lg shadow-primary/25 transition-all hover:brightness-110"
          >
            heilys über Partnerlink ansehen
            <ExternalLink className="h-3.5 w-3.5" aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default PartnerlinkSupportSection;
